import type { BlobLike } from "@pdfking/compatibility"
import { Base64Encode } from "@pdfking/tfunc"

import { BlobToUint8 } from "./BlobToUint8"

/**
 * Converts a Blob to a data URI string.
 *
 * @param blob - The Blob to convert
 * @returns A data URI string in the format `data:<mediatype>;base64,<data>`
 *
 * @example
 * ```ts
 * import { BlobToDataURI } from "@pdfking/tfunc"
 *
 * const blob = new Blob(["Hello"], { type: "text/plain" })
 * const uri = await BlobToDataURI(blob) // "data:text/plain;base64,SGVsbG8="
 * ```
 */
export const BlobToDataURI = (blob: BlobLike): Promise<string> =>
  BlobToUint8(blob).then(
    bytes => `data:${blob.type};base64,${Base64Encode(bytes)}`
  )
